import apiService from '@/api/apiService';

export const listWhiteboardPhotos = (balanceId) =>
    apiService.GET(`/api/admin/balance/version/${balanceId}/whiteboard`);

export const uploadWhiteboardPhoto = (balanceId, file) => {
    const form = new FormData();
    form.append('photo', file);
    // ContentType 須大寫；讓 axios 帶 boundary
    return apiService.POST(
        `/api/admin/balance/version/${balanceId}/whiteboard`,
        form,
        { ContentType: 'multipart/form-data' }
    );
};

export const deleteWhiteboardPhoto = (balanceId, photoId) =>
    apiService.DELETE(
        `/api/admin/balance/version/${balanceId}/whiteboard/${photoId}`
    );

/** 同源相對路徑抓原圖（走 Vite／nginx proxy，避免跨域絕對 URL 預覽失敗） */
export const fetchWhiteboardPhotoBlob = (balanceId, photoId) =>
    apiService.GET(
        `/api/admin/balance/version/${balanceId}/whiteboard/${photoId}/file`,
        {},
        { ResponseType: 'blob' }
    );
